import { computed, effect, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { type ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';

import { filter, map, shareReplay, startWith } from 'rxjs';

import { type BottomBarTabConfig } from '@shared/layouts/bottom-bar/bottom-bar.types';

export interface BottomBarTab extends BottomBarTabConfig {
  isActive: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class BottomBarVisibilityService {
  private readonly router = inject(Router);

  readonly currentPath$ = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map((event) => new URL(event.urlAfterRedirects, window.location.origin).pathname),
    startWith(new URL(this.router.url, window.location.origin).pathname),
    shareReplay(1),
  );

  readonly currentPath = toSignal(this.currentPath$, { requireSync: true });

  readonly showTabs = computed(() => {
    this.currentPath(); // Establish dependency on route changes
    let route: ActivatedRouteSnapshot = this.router.routerState.snapshot.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.data['showTabs'] === true;
  });

  constructor() {
    effect(() => {
      document.body.classList.toggle('has-tabs', this.showTabs());
    });
  }
}
